import { computed, Ref } from 'vue';
import { NavigationItemModel } from '@/types/B2CcontentServerContract';
import authStore from '@/shared/auth/auth.store';
import dictionaryService from '@/core/dictionary/dictionary.service';
import siteContextService from '@/b2c/shared/site-context.service';

export default function useProfile() {
    const shouldShowProfileLinks = computed(() => {
        return !authStore.isSignedIn && !authStore.isSignedInAsPartner;
    });

    const profileLinks = computed<NavigationItemModel[]>(() => {
        const createProfileName = dictionaryService.get('global/generic/usercreateprofilelink');
        const loginName = dictionaryService.get('global/generic/userloginlink');
        return (shouldShowProfileLinks.value ? [
            {
                name: createProfileName,
                ...siteContextService.createProfileLink,
            },
            {
                name: loginName,
                ...siteContextService.loginLink,
            },
        ] : []) as NavigationItemModel[];
    });

    const accountName = computed<string>(() => {
        return authStore.isSignedInAsPartner ? authStore.userData.accountName : authStore.userData.name;
    });

    const shouldShowLogout = computed(() => {
        return authStore.isSignedIn;
    });

    const shouldShowToggleNetPrice: Ref<boolean> = computed(() => {
        return authStore.isSignedInAsPartner;
    });

    const shouldShowCountrySelection: Ref<boolean> = computed(() => {
        return !authStore.isSignedInAsPartner;
    });

    const isSignedInAsPartner = computed(() => authStore.isSignedInAsPartner);
    const hideNetPrice = computed(() => authStore.hideNetPrice);

    return {
        profileLinks,
        accountName,
        shouldShowLogout,
        shouldShowToggleNetPrice,
        shouldShowCountrySelection,
        isSignedInAsPartner,
        hideNetPrice,
    };
}
